import React from 'react';
import { Paper, Typography, Box, Stack, Button, alpha, useTheme } from '@mui/material';
import TutorSessionsByDateTable from '../../Components/Table/TutorSessionByDateTable';

const LogAnalytics = ({ tutorsSessions }) => {
  const theme = useTheme();

  // Placeholder for future export functionality
  const handleExport = () => {
    console.log("Exporting session logs...");
    // You can implement CSV export logic here later
  };

  return (
    <Box>
      <Paper 
        variant="outlined" 
        sx={{ 
          overflow: 'hidden', // Ensures the table doesn't break the Paper's border radius
          bgcolor: 'background.paper',
          border: `1px solid ${theme.palette.divider}`
        }}
      >


        {/* The Data Table */}
        <Box sx={{ p: 1 }}>
          <TutorSessionsByDateTable data={tutorsSessions} />
        </Box>
      </Paper>

      {/* Footer / Summary Info */}
      <Box sx={{ mt: 2, px: 1 }}>
        <Typography variant="caption" color="text.secondary">
          Showing all logs within the selected date range. For older records, please adjust the global filters at the top of the dashboard.
        </Typography>
      </Box>
    </Box>
  );
};

export default LogAnalytics;